var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.013 0c1.87.003 3.569.74 4.822 1.939L12.845.93A.677.677 0 0114 1.41v3.784a.677.677 0 01-.677.677H9.539a.677.677 0 01-.48-1.156l1.18-1.179a4.708 4.708 0 00-3.197-1.278c-2.608-.022-4.806 2.088-4.784 4.783.022 2.556 2.094 4.7 4.742 4.7 1.16 0 2.258-.413 3.123-1.172a.338.338 0 01.462.016l1.12 1.12a.34.34 0 01-.014.491A7 7 0 010 7C-.001 3.14 3.15-.007 7.012 0z",
    fill: "#D4366A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.c6ed975cc73aedc76ccb026e4c6abac6.svg";
export { ForwardRef as ReactComponent };